import React from "react";

/**
 * The Lintel — HearthHouse logo
 * One continuous line forming a house with a glowing ember inside.
 * Use `tone` to switch between "ink" (dark on light) or "cream" (light on dark).
 */
export default function Logo({ size = 36, tone = "ink", showWord = false, className = "" }) {
  const stroke = tone === "cream" ? "#F2EFE8" : "#231C18";
  const ember = "#B85A37";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="HearthHouse logo"
        role="img"
      >
        {/* One continuous house line: starts left wall, up to roof peak, down right wall, doorway opening, base */}
        <path
          d="M7 41 V22 L24 8 L41 22 V41 H30 V29 H18 V41 Z"
          stroke={stroke}
          strokeWidth="2.2"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
        />
        {/* Ember dot — the hearth itself */}
        <circle cx="24" cy="22.5" r="2.6" fill={ember} />
        <circle cx="24" cy="22.5" r="5.2" stroke={ember} strokeOpacity="0.25" strokeWidth="1.2" fill="none" />
      </svg>
      {showWord && (
        <span className="font-display tracking-tight leading-none" style={{ color: stroke, fontSize: size * 0.62 }}>
          HearthHouse
        </span>
      )}
    </span>
  );
}
